/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../../../app/@shared/tracking/navigation-performance-tracking.component';
import * as import2 from '../../../../app/@shared/tracking/tracking.service';
import * as import3 from '../../../../app/@shared/tracking/tracking.config';
const styles_NavigationPerformanceTrackingComponent:any[] = ([] as any[]);
export const RenderType_NavigationPerformanceTrackingComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_NavigationPerformanceTrackingComponent,
  data: {}
}
);
export function View_NavigationPerformanceTrackingComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[(l()(),import0.ɵeld(0,(null as any),(null as any),0,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any)))],(null as any),(null as any));
}
function View_NavigationPerformanceTrackingComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'fl-navigation-performance-tracking',([] as any[]),(null as any),(null as any),(null as any),View_NavigationPerformanceTrackingComponent_0,RenderType_NavigationPerformanceTrackingComponent)),
    import0.ɵdid(114688,(null as any),0,import1.NavigationPerformanceTrackingComponent,[
      import2.Tracking,
      import3.TRACKING_CONFIG
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const NavigationPerformanceTrackingComponentNgFactory:import0.ComponentFactory<import1.NavigationPerformanceTrackingComponent> = import0.ɵccf('fl-navigation-performance-tracking',import1.NavigationPerformanceTrackingComponent,View_NavigationPerformanceTrackingComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvbmF2aWdhdGlvbi1wZXJmb3JtYW5jZS10cmFja2luZy5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQvd2ViYXBwL3NyYy9hcHAvQHNoYXJlZC90cmFja2luZy9uYXZpZ2F0aW9uLXBlcmZvcm1hbmNlLXRyYWNraW5nLmNvbXBvbmVudC50cyIsIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvbmF2aWdhdGlvbi1wZXJmb3JtYW5jZS10cmFja2luZy5jb21wb25lbnQudHMuTmF2aWdhdGlvblBlcmZvcm1hbmNlVHJhY2tpbmdDb21wb25lbnQuaHRtbCIsIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvbmF2aWdhdGlvbi1wZXJmb3JtYW5jZS10cmFja2luZy5jb21wb25lbnQudHMuTmF2aWdhdGlvblBlcmZvcm1hbmNlVHJhY2tpbmdDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8bmctY29udGFpbmVyPjwvbmctY29udGFpbmVyPiIsIjxmbC1uYXZpZ2F0aW9uLXBlcmZvcm1hbmNlLXRyYWNraW5nPjwvZmwtbmF2aWdhdGlvbi1wZXJmb3JtYW5jZS10cmFja2luZz4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozt5QkNBQTs7OztJQ0FBO2dCQUFBOzs7SUFBQTtLQUFBOzs7SUFBQTs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/@shared/tracking/navigation-performance-tracking.component.ngfactory.ts